<template>
<div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Banco de indicadores</span>
      </h5>
    </div>
    <div class="card-body">
      <b-container>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Fortalezas" active>
              <performance :doesEdit="true" :indicatorType="1" :indicatorName="'fortaleza'" />
            </b-tab>
            <b-tab title="Débilidades">
              <performance :doesEdit="true" :indicatorType="2" :indicatorName="'debilidad'" />
            </b-tab>
            <b-tab title="Recomendaciones">
              <performance :doesEdit="true" :indicatorType="3" :indicatorName="'recomendación'" />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import performance from '@/components/custom/performance'
import { mapState } from 'vuex'

export default {
  components: {
    performance,
  },
  name: 'performanceIndicator',
  data() {
    return {
    }
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>
